import type OtpSettings from 'owa-service/lib/contract/OtpSettings';
import type { BookingOtpSettings } from 'owa-graph-schema';

const mapBookingOtpSettings = (otpVerificationSetting: BookingOtpSettings): OtpSettings => {
    switch (otpVerificationSetting) {
        case 'Disabled':
            return 1;
        case 'Enabled':
            return 2;
        default:
            return 0;
    }
};

export default mapBookingOtpSettings;
